import { useEffect, useState } from 'react'

const getDevice = width => {
  if (width < 600) return 'mobile'
  if (width < 960) return 'tablet'
  return 'desktop'
}

const useDevice = () => {
  const [device, setDevice] = useState(getDevice(window.innerWidth))

  useEffect(() => {
    const onResize = () => {
      setDevice(getDevice(window.innerWidth))
    }

    window.addEventListener('resize', onResize)

    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [])

  return {
    isMobile: device === 'mobile',
    isTablet: device === 'tablet',
    isDesktop: device === 'desktop'
  }
}

export default useDevice
